import { Pipe, type PipeTransform } from '@angular/core';
import { format, isMatch, isValid, parse, parseISO } from 'date-fns';
import { type TimeFormat } from '../types';

@Pipe({
  name: 'displayDate',
  standalone: true,
  pure: false,
})
export class DisplayDatePipe implements PipeTransform {
  transform(
    value: string | Date | number | undefined | null,
    defaultValue?: string,
    showTime = true,
    timeFormat: TimeFormat = '12h',
  ): string {
    if (!value) return defaultValue ?? '';

    const { date, onlyTime } = this.parseDate(value);

    if (!date || !isValid(date)) {
      console.warn(`Invalid date passed to DisplayDatePipe:`, value);
      return value.toString();
    }

    if (showTime && onlyTime) {
      return format(date, timeFormat === '12h' ? 'hh:mm a' : 'HH:mm');
    }

    return showTime
      ? format(date, `MM/dd/yyyy, ${timeFormat === '12h' ? 'hh:mm a' : 'HH:mm'}`)
      : format(date, 'MM/dd/yyyy');
  }

  private parseDate(value: string | Date | number): { date: Date | null; onlyTime: boolean } {
    if (value instanceof Date) return { date: value, onlyTime: false };
    if (typeof value === 'number') return { date: new Date(value), onlyTime: false };
    if (isMatch(value, 'HH:mm:ss')) {
      return { date: parse(value, 'HH:mm:ss', new Date()), onlyTime: true };
    }
    return { date: parseISO(value), onlyTime: false };
  }
}
